import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/shared/PageHeader';
import { RefreshButton } from '@/components/shared/RefreshButton';
import { LoadingState } from '@/components/shared/LoadingState';
import { ErrorState } from '@/components/shared/ErrorState';
import { useStatistics } from '@/lib/hooks';

export const Route = createFileRoute('/_auth/_admin/admin/statistics/')({
  component: StatisticsComponent,
});

function StatisticsComponent() {
  const { isLoading, isError, error, refetch } = useStatistics();

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return <ErrorState title={error.name} message={error.message} />;
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Статистика"
        description=""
        action={<RefreshButton onClick={refetch} />}
      />


      <div className="grid gap-6 md:grid-cols-2">
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        {/*<UserMetrics stats={data} />*/}
        {/*<WalletMetrics stats={data} />*/}
      </div>
    </div>
  );
}
